import * as types from './logSourcesActionTypes';

export default (state = [], action) => {
    switch(action.type) {
        case types.SELECT_FILTER:
        {
            const exists = state.filter(f => f === action.value).length > 0;
            if(exists) {
                return state.filter(f => f !== action.value);
            }

            return [...state, action.value];
        }
        case '@@router/LOCATION_CHANGE':
        {
            const payload = action.payload;
            const hasPreselectedType = payload.pathname.endsWith('log-sources') && payload.hash.length > 0;
            if(hasPreselectedType) {
                return [payload.hash.substring(1)];
            }
            return [];
        }
        default:
            return state;
            
    }
};


// WEBPACK FOOTER //
// ./src/log-sources/selectedFiltersReducer.js